import React from "react";

export const WalletIcon = () => {
  return (
    <svg
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.6 4.13342H7V3.7601H5.6V4.13342ZM6.53333 1.89352H0V5.62668C0 5.83275 0.209067 6 0.466667 6H6.53333C6.79093 6 7 5.83275 7 5.62668V4.50674H5.36667C5.23787 4.50674 5.13333 4.4233 5.13333 4.32008V3.57345C5.13333 3.47041 5.23787 3.38679 5.36667 3.38679H7V2.26684C7 2.06077 6.79093 1.89352 6.53333 1.89352ZM6.53333 0.213601C6.53333 0.110379 6.47827 0.0532596 6.35833 0.0153681C6.26593 -0.0139373 6.1761 0.00361079 6.06667 0.026943L0 1.52021H6.53333V0.213601Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
